import type { StyleLayer } from './utils/types'

export const layers_parkingTilda_street_cutouts: StyleLayer[] = [
  {
    id: 'cutout-base',
    type: 'fill',
    paint: {
      'fill-color': [
        'match',
        ['get', 'category'],
        [
          'bus_stop',
          'bus_stop_conditional',
          'tram_stop',
          'tree_pit',
          'bus_stop_kerb',
          'bus_stop_centerline',
        ],
        'hsla(48, 96%, 53%, 0.7)',
        [
          'mobility_hub',
          'bicycle_rental',
          'motorcycle_parking',
          'small_electric_vehicle_parking',
          'bicycle_parking',
          'parklet',
        ],
        'rgba(33, 55, 253, 0.59)',
        [
          'street_lamp',
          'tree',
          'street_cabinet',
          'advertising',
          'bollard',
          'recycling',
          'vending_parking_tickets',
          'collision_protection',
          'water_well',
          'traffic_sign',
          'fire_hydrant',
          'barrier',
          'other',
        ],
        'hsla(242, 39%, 31%, 0.88)',
        [
          'crossing_zebra',
          'crossing_marked',
          'crossing_buffer_marking',
          'traffic_calming_choker',
          'crossing_traffic_signals',
          'crossing_kerb_extension',
          'crossing_continuous',
        ],
        'hsla(133, 65%, 35%, 0.73)',
        ['driveway', 'driveway_corner_kerb', 'loading_ramp', 'kerb_extension', 'kerb_lowered'],
        'rgba(97, 97, 97, 0.61)',
        ['road_marking_restricted_area', 'turning_circle', 'turning_loop'],
        'rgba(255, 255, 255, 0.67)',
        ['intersection_corner'],
        '#f2ac5b',
        'hsla(0, 71%, 0%, 0)',
      ],
      'fill-opacity': 0.56,
    },
  },
  {
    id: 'cutout-category-ring',
    type: 'line',
    minzoom: 16.5,
    layout: {
      'line-join': 'round',
    },
    paint: {
      'line-color': [
        'match',
        ['get', 'category'],
        [
          'bus_stop',
          'bus_stop_conditional',
          'tram_stop',
          'tree_pit',
          'bus_stop_kerb',
          'bus_stop_centerline',
        ],
        'hsla(48, 96%, 53%, 0.7)',
        [
          'mobility_hub',
          'bicycle_rental',
          'motorcycle_parking',
          'small_electric_vehicle_parking',
          'bicycle_parking',
          'parklet',
        ],
        'rgba(33, 55, 253, 0.59)',
        [
          'street_lamp',
          'tree',
          'street_cabinet',
          'advertising',
          'bollard',
          'recycling',
          'vending_parking_tickets',
          'collision_protection',
          'water_well',
          'traffic_sign',
          'fire_hydrant',
          'barrier',
          'other',
        ],
        'hsla(242, 39%, 31%, 0.88)',
        [
          'crossing_zebra',
          'crossing_marked',
          'crossing_buffer_marking',
          'traffic_calming_choker',
          'crossing_traffic_signals',
          'crossing_kerb_extension',
          'crossing_continuous',
        ],
        'hsla(133, 65%, 35%, 0.73)',
        ['driveway', 'driveway_corner_kerb', 'loading_ramp', 'kerb_extension', 'kerb_lowered'],
        'rgba(97, 97, 97, 0.61)',
        ['road_marking_restricted_area', 'turning_circle', 'turning_loop'],
        'rgba(255, 255, 255, 0.67)',
        ['intersection_corner'],
        '#f2ac5b',
        'hsla(0, 71%, 0%, 0)',
      ],
      'line-offset': 2.5,
      'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.67, 20, 5.33],
    },
  },
  {
    id: 'cutout-border',
    type: 'line',
    minzoom: 16.5,
    layout: {
      'line-join': 'round',
    },
    paint: {
      'line-color': 'hsl(175, 0%, 43%)',
      'line-dasharray': [1.25, 0.75],
      'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.33, 20, 2.67],
    },
  },
]
